import {FC, useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Loading} from '../../../../components/Loading/Loading'
import {GET, POST, PUT} from '../../../../services/api'
import {i18n} from '../../../../translate/i18n'
import Swal from 'sweetalert2'
import styles from './frenet.module.css'
import {Button} from '../../../../components/Button/Button'
import FrenetImg from '../../../../assets/freights/frenet-full.png'
import {Input} from '../../../../components/Input/Input'
import ReactLoading from 'react-loading'

type PluginconfigResponseType = {
  id: number
  name: string
  plugintypeId: number
  plugintemplateId: number
  content: ContentFrenetType
}

type ContentFrenetType = {
  able: boolean
  token: string
  declaredValue: boolean
}

// type JadlogResponseType = {
//   id: string
//   nickName: string
// }

const FrenetContent: FC = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [hasConfig, setHasConfig] = useState(false)
  const [id, setId] = useState(0)
  const [able, setAble] = useState(true)
  const [token, setToken] = useState('')
  const [declaredValue, setDeclaredValue] = useState(false)
  const [branchCode, setBranchCode] = useState('none')
  const [validToken, setValidToken] = useState(true)
  const [loadingToken, setLoadingToken] = useState(false)
  const [showAlert, setShowAlert] = useState(true)
  const [weight, setWeight] = useState<number | null>(null)
  const [height, setHeight] = useState<number | null>(null)
  const [width, setWidth] = useState<number | null>(null)
  const [deep, setDeep] = useState<number | null>(null)

  // const getJadlogPosts = async (tk: string) => {
  //   try {
  //     const jadlogPostsRes = await POST(`/frenet/jadlog`, {
  //       token: tk
  //     })
  //     if(jadlogPostsRes.data && jadlogPostsRes.success && jadlogPostsRes.data.length > 0){
  //       const jadLogSelect = jadlogPostsRes.data.map((jdPost: JadlogResponseType) => ({
  //         value: jdPost.id,
  //         select: jdPost.nickName
  //       }))
  //       setJadlogPosts([...jadlogPosts, ...jadLogSelect])
  //     }
  //   } catch(e){
  //     console.log(e)
  //   }
  // }

  const getFrenet = async () => {
    try {
      const pluginconfigRes = await GET(`/pluginconfig`)
      const pluginconfigFinded = pluginconfigRes.data.find(
        (pgConfig: PluginconfigResponseType) => pgConfig.plugintemplateId === 119
      )
      if (pluginconfigFinded && pluginconfigFinded.content) {
        setHasConfig(true)
        setId(pluginconfigFinded.id)
        setAble(pluginconfigFinded.content.able)
        setToken(pluginconfigFinded.content.token)
        setDeclaredValue(pluginconfigFinded.content.declaredValue)
        setBranchCode(
          pluginconfigFinded.content.branchCode ? pluginconfigFinded.content.branchCode : 'none'
        )
        setWeight(pluginconfigFinded.content.weight)
        setHeight(pluginconfigFinded.content.height)
        setWidth(pluginconfigFinded.content.width)
        setDeep(pluginconfigFinded.content.deep)
        // await getJadlogPosts(pluginconfigFinded.content.token)
      }
    } catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao obter configuração!',
      }).then(() => {
        navigate('/configuracoes/taxa-entrega')
      })
    }
  }
  const save = async () => {
    try {
      if (!validToken) {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Token inválido!',
        })
        return
      }
      if (!weight || !height || !width || !deep) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: 'Por favor, preencha todos os campos de peso e dimensões!',
        })
        return
      }
      let error = false
      setLoading(true)
      if (hasConfig) {
        const result = await PUT(`/pluginconfig/${id}`, {
          content: {able, token, declaredValue, branchCode, weight, height, width, deep},
        })
        if (!result.success) error = true
      } else {
        const result = await POST(`/pluginconfig`, {
          plugintypeId: 1,
          plugintemplateId: 119,
          name: 'Frenet',
          content: {able, token, declaredValue, branchCode, weight, height, width, deep},
        })
        if (!result.success) error = true
      }
      setLoading(false)
      if (error) {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao alterar configuração!',
        }).then(() => navigate('/configuracoes/taxa-entrega'))
      } else {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Configuração salva com sucesso!',
        }).then(() => navigate('/configuracoes/taxa-entrega'))
      }
    } catch (e) {
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao alterar configuração!',
      })
    }
  }

  const verifyToken = async () => {
    try {
      setValidToken(true)
      setLoadingToken(true)
      const jadlogPostsRes = await POST(`/frenet/jadlog`, {
        token,
      })
      setLoadingToken(false)
      if (jadlogPostsRes.data && jadlogPostsRes.success && jadlogPostsRes.data.length > 0) {
        setValidToken(true)
      } else {
        setValidToken(false)
      }
    } catch (e) {
      setLoadingToken(false)
      setValidToken(false)
      console.log(e)
    }
  }

  const init = async () => {
    setLoading(true)
    await getFrenet()
    setLoading(false)
  }

  useEffect(() => {
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t(`frenet.title`)}</span>
              </h3>
            </div>
            <div className='card-body d-flex flex-column gap-5'>
              <div className={styles.goBack}>
                <img src={FrenetImg} alt='Frenet' />
                {/* <p onClick={() => navigate('/configuracoes/taxa-entrega')}>
                  {i18n.t(`frenet.back`)}
                </p> */}
              </div>
              <div className={styles.configItem}>
                <h2>{i18n.t(`frenet.integration`)}</h2>
                <div className={`${styles.configInput} w-50`}>
                  <Input
                    inputAttr={{
                      type: 'text',
                    }}
                    placeholder={'-'}
                    label={'Token'}
                    name={'Token'}
                    value={token}
                    change={setToken}
                    blur={() => verifyToken()}
                    alarm={token && !validToken ? true : false}
                    alarmText={i18n.t(`frenet.valid_token`)}
                    toolTip={true}
                    toolTipIcon={'info-circle'}
                    toolTiptext={String(i18n.t(`frenet.getToken`))}
                  />
                  {loadingToken && (
                    <div className='d-flex flex-row gap-2 align-items-center'>
                      <ReactLoading type='spin' color='#D5D5D5' height={15} width={15} />
                      <p className='fw-normal text-gray-600 mt-4'>Validando</p>
                    </div>
                  )}
                </div>
              </div>
              <div className={styles.configItem}>
                <h2>{i18n.t(`frenet.config`)}</h2>
                {/* <p>{i18n.t(`frenet.dimensions`)}</p>
                    <div className={styles.configDimensions}>
                        <Input
                            inputAttr={{
                            type: 'text',
                            }}
                            placeholder={'-'}
                            label={i18n.t(`frenet.height`)}
                            name={i18n.t(`frenet.height`)}
                            change={() => { }}
                        />
                        <Input
                            inputAttr={{
                            type: 'text',
                            }}
                            placeholder={'-'}
                            label={i18n.t(`frenet.width`)}
                            name={i18n.t(`frenet.width`)}
                            change={() => { }}
                        />
                        <Input
                            inputAttr={{
                            type: 'text',
                            }}
                            placeholder={'-'}
                            label={i18n.t(`frenet.length`)}
                            name={i18n.t(`frenet.length`)}
                            change={() => { }}
                        />
                    </div> */}
                <Input
                  inputAttr={{
                    type: 'select',
                  }}
                  label={i18n.t('frenet.value')}
                  options={[
                    {
                      select: i18n.t(`frenet.use`),
                      value: true,
                    },
                    {
                      select: i18n.t(`frenet.dont_use`),
                      value: false,
                    },
                  ]}
                  value={declaredValue}
                  change={setDeclaredValue}
                  smalltext={i18n.t('frenet.declared_value')}
                />
                {/* <Input
                        inputAttr={{
                            type: 'select',
                        }}
                        label={i18n.t('frenet.branchCode')}
                        options={jadlogPosts}
                        value={branchCode}
                        change={setBranchCode}
                    /> */}
                {/* <Input
                        inputAttr={{
                            type: 'select',
                        }}
                        label={i18n.t('frenet.price')}
                        options={[
                            {
                                select: i18n.t(`frenet.yes`),
                                value: true,
                            },
                            {
                                select: i18n.t(`frenet.no`),
                                value: false,
                            },
                        ]}
                        value={false}
                        change={() => { }}
                    /> */}
                <div className={styles.configDimensions}>
                  <div className='me-5'>
                    <Input
                      inputAttr={{
                        type: 'number',
                      }}
                      placeholder='0'
                      label={i18n.t(`frenet.weight_frenet`)}
                      change={(value: number) => {
                        setWeight(value)
                      }}
                      value={weight}
                      marginTop='mt-0'
                    />
                  </div>
                  <div className='me-5'>
                    <Input
                      inputAttr={{
                        type: 'number',
                      }}
                      placeholder='0'
                      label={i18n.t(`frenet.height_frenet`)}
                      change={(value: number) => {
                        setHeight(value)
                      }}
                      value={height}
                      marginTop='mt-0'
                    />
                  </div>
                  <div className='me-5'>
                    <Input
                      inputAttr={{
                        type: 'number',
                      }}
                      placeholder='0'
                      label={i18n.t(`frenet.width_frenet`)}
                      change={(value: number) => {
                        setWidth(value)
                      }}
                      value={width}
                      marginTop='mt-0'
                    />
                  </div>
                  <div className='me-5'>
                    <Input
                      inputAttr={{
                        type: 'number',
                      }}
                      placeholder='0'
                      label={i18n.t(`frenet.depth_frenet`)}
                      change={(value: number) => {
                        setDeep(value)
                      }}
                      value={deep}
                      marginTop='mt-0'
                    />
                  </div>
                </div>
                <div
                  className={`${styles.alertBox} ${!showAlert ? styles.alertBoxCollapsed : ''}`}
                  onClick={() => !showAlert && setShowAlert(true)}
                >
                  <button
                    className={styles.closeButton}
                    onClick={(e) => {
                      e.stopPropagation()
                      setShowAlert(!showAlert)
                    }}
                    title={showAlert ? 'Recolher alerta' : 'Expandir alerta'}
                  >
                    <i className='bi bi-chevron-up'></i>
                  </button>
                  <div className={styles.alertBoxContent}>
                    <i className={`bi bi-exclamation-triangle-fill ${styles.alertIcon}`}></i>
                    {!showAlert ? (
                      <div>
                        <span className={styles.alertText}>{i18n.t('frenet.alert_title')}</span>
                        <strong>{i18n.t('frenet.alert_warning')}</strong>{' '}
                        {i18n.t('frenet.alert_description')}
                      </div>
                    ) : (
                      <div className={styles.alertText}>
                        <strong>{i18n.t('frenet.alert_warning')}</strong>{' '}
                        {i18n.t('frenet.alert_description')}
                        <br />
                        {i18n.t('frenet.alert_wrong_values')}
                        <ul>
                          <li>
                            <strong>{i18n.t('frenet.alert_overpriced')}</strong>
                          </li>
                          <li>
                            <strong>{i18n.t('frenet.alert_additional_costs')}</strong>
                          </li>
                        </ul>
                        {i18n.t('frenet.alert_recommendation')}
                        <br />
                        <br />
                        <strong>{i18n.t('frenet.alert_reference')}</strong>
                        <ul>
                          <li>
                            <strong>📦 {i18n.t('frenet.alert_small_products')}</strong>{' '}
                            {i18n.t('frenet.alert_small_examples')}:
                            <br />
                            {i18n.t('frenet.alert_small_weight')}
                            <br />
                            {i18n.t('frenet.alert_small_dimensions')}
                          </li>
                          <li>
                            <strong>📦 {i18n.t('frenet.alert_medium_products')}</strong>{' '}
                            {i18n.t('frenet.alert_medium_examples')}:
                            <br />
                            {i18n.t('frenet.alert_medium_weight')}
                            <br />
                            {i18n.t('frenet.alert_medium_dimensions')}
                          </li>
                          <li>
                            <strong>📦 {i18n.t('frenet.alert_large_products')}</strong>{' '}
                            {i18n.t('frenet.alert_large_examples')}:
                            <br />
                            {i18n.t('frenet.alert_large_weight')}
                            <br />
                            {i18n.t('frenet.alert_large_dimensions')}
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className='d-flex w-100 justify-content-between px-9 pb-5'>
              <Button
                text={i18n.t(`buttons.back`)}
                color='info'
                size='small'
                horizontalPadding={6}
                btnAttr={{
                  type: 'button',
                }}
                click={() => navigate('/configuracoes/taxa-entrega')}
                btnClass='fw-bolder'
              />
              <Button
                text={i18n.t(`buttons.save`)}
                color='primary'
                size='small'
                horizontalPadding={6}
                btnAttr={{
                  type: 'button',
                }}
                click={() => save()}
                btnClass='fw-bolder'
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const Frenet: FC = () => {
  const {id} = useParams()

  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`ia.title_config`), path: 'ia/config', isActive: true},
          {title: i18n.t(`ia.config`), path: `ia/config/${id}`, isActive: true},
        ]}
      >
        {i18n.t(`ia.config`)}
      </PageTitle>
      <FrenetContent />
    </>
  )
}

export {Frenet}
